import { useCallback } from 'react';
import { ethers } from 'ethers';

function useGetReceiveAmount(): (
  sendAmount: string,
  feeAmount: string,
  tokenAssetDecimals?: number
) => string {
  return useCallback(
    (
      sendAmount: string,
      feeAmount: string,
      tokenAssetDecimals?: number
    ): string => {
      const decimalPlaces = tokenAssetDecimals || 18;

      try {
        const parsedSendAmount = ethers.utils.parseUnits(
          sendAmount || '0',
          decimalPlaces
        );
        const parsedFeeAmount = ethers.utils.parseUnits(
          feeAmount || '0',
          decimalPlaces
        );
        return ethers.utils.formatUnits(
          parsedSendAmount.sub(parsedFeeAmount),
          decimalPlaces
        );
      } catch (err) {
        return 'NaN';
      }
    },
    []
  );
}

export default useGetReceiveAmount;
